"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitRecipe = void 0;
const events_1 = require("events");
function emitRecipe(forEach) {
    return function () {
        const emitter = new events_1.EventEmitter();
        process.nextTick(async () => {
            try {
                await forEach.call(this, (x) => emitter.emit('data', x));
                emitter.emit('end');
            }
            catch (error) {
                if (emitter.listenerCount('error') === 0) {
                    throw error;
                }
                emitter.emit('error', error);
            }
        });
        return emitter;
    };
}
exports.emitRecipe = emitRecipe;
